export default {
    /**
     * Deprecated
     * should be moved to order status
     */
    STATUS: {
        ORDERED: 'ORDERED',
        PROCESSED: 'PROCESSED',
        REFUNDED: 'REFUNDED',
        CANCELLED: 'CANCELLED',
        DELIVERED: 'DELIVERED',
        PAID: 'PAID',
    },
    PAYMENT_STATUS: {
        SUCCEEDED: 'SUCCEEDED',
        FAILED: 'FAILED',
    },
    DETAIL_TYPES: {
        ONE_ORDER: 'ONE_ORDER',
        LOYALTY_TRANSACTIONS_BY_ORDER: 'LOYALTY_TRANSACTION_BY_ORDER',
    },
    STATISTICS: {
        VIEW: {
            CHART: 0,
            TABLE: 1,
        },
        TYPE: {
            REVENUE: 'revenue',
            TRANSACTIONS: 'transactions',
        },
    },
    TYPES: {
        HOTEL_ONLY: 'HOTEL_ONLY',
        PRE_PAID: 'PRE_PAID',
        LN_VIP_PACKAGE: 'LN_VIP_PACKAGE',
        DYNAMIC: 'DYNAMIC',
        PRE_BUNDLE: 'PRE_BUNDLE',
    },
};
